import { useEffect, useState } from 'react';

export default function usePrevious<T>(value: T) {
  const [history, setHistory] = useState<{ current: T; previous: T | undefined }>({ current: value, previous: undefined });

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setHistory(prev => (Object.is(prev.current, value) ? prev : { current: value, previous: prev.current }));
    }, 0);

    return () => clearTimeout(timeoutId);
  }, [value]);

  return history.previous;
}

// https://github.com/Andarist/use-previous
